export { default } from "./InputRange"
